<template>
  <card :class="[baseCss, 'select-none']" :elevation="elevation" :data-uuid="uuid" v-if="otp.length" :bg-color="bgColor" :bg-color-lightness="bgColorLightness">
    <card-text :padding-off="dense">
      <async-form :form-data="{}" autocomplete="off" spellcheck="false">
        <table-layout y-align="middle" x-align="center">
          <row>
            <cell v-for="index in length" :key="index" :class="['p-1']">
              <text-field @keyup="onKeyup($event, index)" @focus="onFocus(index)" :spellcheck="false" autocomplete="off" :type="type" :data-index="index" :placeholder="placeholder" :max-length="1" :color="color" v-model="otp[index - 1]" :color-lightness="colorLightness" />
            </cell>
          </row>
        </table-layout>
      </async-form>
    </card-text>
    <reactive-style>
    .{{ baseCss }}[data-uuid="{{ uuid }}"] input
    {
      font-size: {{ fontSize }}em;
    }
    </reactive-style>
  </card>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'OtpInput',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      otp: [],
      uuid: this.$uuidv4(),
      baseCss: this.componentBaseCss('otp-input', [])
    }
  },
  props: {
    length: {
      type: Number,
      default: 6
    },
    color: {
      type: String,
      default: 'black'
    },
    colorLightness: {
      type: Number,
      default: null
    },
    fontSize: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: [
        String,
        Number
      ]
    },
    dense: {
      type: Boolean
    },
    autofocusFirst: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text',
      validator: value => {
        return [
          'text',
          'password'
        ].includes(value)
      }
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    }
  },
  beforeDestroy () {
    this.getInputs().forEach(input => {
      input.removeEventListener('paste', this.paste)
    })
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.otp = Array.from(Array(this.length).keys()).map(() => {
        return ''
      })
      this.$nextTick(() => {
        this.getInputs().forEach(input => {
          input.addEventListener('paste', this.paste)
          input.spellcheck = false
          input.autocomplete = 'off'
          input.autocorrect = 'off'
          input.autocapitalize = 'none'
          input.tabIndex = '-1'
        })
        if (this.autofocusFirst) {
          this.select(1)
        }
      })
    },
    getInputs () {
      return this.$el.querySelectorAll('input')
    },
    onKeyup ($event, index) {
      const code = $event.code
      switch (code) {
        case 'Backspace':
          this.select(index - 1)
          break
        case 'Space':
          this.input(index).value = ''
          break
        case 'ControlLeft':
        case 'ControlRight':
        case 'MetaLeft':
        case 'MetaRight':
        case 'ShiftLeft':
        case 'ShiftRight':
        case 'Tab':
        case 'Enter':
        case 'AltLeft':
        case 'AltRight':
          $event.preventDefault()
          break
        default:
          this.onInput(index)
      }
    },
    onFocus (input) {
      this.select(input)
    },
    input (index) {
      return this.$el.querySelector(`[data-index="${index}"] input`)
    },
    select (index) {
      const input = this.input(index)
      if (input) {
        this.input(index).select()
      }
    },
    onInput (index) {
      const input = this.input(index + 1)
      if (input) {
        input.select()
      }
      this.ifReady()
    },
    ifReady () {
      this.$nextTick(() => {
        const otp = this.otp
        if (!otp.includes('')) {
          this.$emit('ready', {
            otp: otp.join('')
          })
        }
      })
    },
    paste (event) {
      let pasted
      let clipboard
      event.stopPropagation()
      event.preventDefault()
      clipboard = event.clipboardData || window.clipboardData
      pasted = clipboard.getData('Text')
      this.otp = pasted.split('').slice(0, this.length)
      this.ifReady()
    }
  }
}
</script>
<style>
.bcq-otp-input input
{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/otp-input/otp-input.vue